var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "appfade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.appIsLoaded,
            expression: "appIsLoaded"
          }
        ],
        staticClass: "home-page--template page-template"
      },
      [
        _c("div", { staticClass: "container-fluid-full-width relative" }, [
          _c(
            "section",
            {
              staticClass:
                "container-fluid-full-width relative vh-100 relative center flex flex-column justify-center content-center items-center overflow-y-hidden"
            },
            [
              _c(
                "div",
                {
                  staticClass: "db relative w-100 center z-3 mw6 content-wrap"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "db relative center mv3 mv4-ns home-mob-rep-badge-animation"
                    },
                    [
                      _c("router-link", {
                        staticClass: "bb pointer",
                        attrs: { to: "/home/" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "db relative center title-bar",
                    attrs: { id: "title-bar-1" }
                  }),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticClass:
                        "f2 mt1 mb1 lh-solid ttu tc is-bebas is-white"
                    },
                    [
                      _vm._v("\n              Mobocratic\n              "),
                      _c("span", { staticClass: "db mv1" }, [
                        _vm._v("Republic")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "db relative center title-bar",
                    attrs: { id: "title-bar-2" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "db relative center mt3" }, [
                    _c(
                      "p",
                      { staticClass: "f5 f3-ns mv1 tc ttu is-bebas is-white" },
                      [
                        _vm._v(
                          "\n                Curating experiences in Chicago and beyond\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "f3 tc mt2 mb0 nb3 ttu is-portago is-white"
                      },
                      [
                        _vm._v(
                          "\n                Be the first to hear details\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "db relative center mv1 mw21rem" },
                      [_c("signup")],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "db absolute bottom-0 left-0 right-0 h2 z-4 cta-banner",
                  attrs: { id: "cta-banner" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "db relative center no-underline pointer home-cta-link",
                      attrs: {
                        href: _vm.page.next_event_banner.link,
                        target: "_blank"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "db relative center h2 bg-blue" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex h-100 flex-row justify-around items-center content-center center ph1",
                              staticStyle: { "max-width": "54rem" }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "f5 tc ttu lh-title mv0 is-bebas is-white cta-banner-text",
                                  attrs: { id: "cta-banner-text" }
                                },
                                [
                                  _vm._v("\n                    Next Event: "),
                                  _c("span", {}, [
                                    _vm._v(
                                      _vm._s(_vm.page.next_event_banner.text)
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "relative container-fluid" }, [
          _c("section", { staticClass: "db relative z-3 center mw8" })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }